import { render } from "./Promocodes.vue?vue&type=template&id=0849b2fa&ts=true"
import script from "./Promocodes.vue?vue&type=script&lang=ts"
export * from "./Promocodes.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/asaskevich/Work/sequoia-cabinet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__